//these are the selectors that we never want to lock because they are clickable content and not inputs
const lockWhitelistSelectors = ['common-info-icon', 'goa-callout', '.no-lock', 'd3-details', '.info-text-d3'];

function applyLock(root: ParentNode): void {
  if (root instanceof HTMLElement) {
    root.style.pointerEvents = 'none';
  }
}
function applyWhitelist(root: ParentNode): void {
  lockWhitelistSelectors.forEach((selector) => {
    root.querySelectorAll(selector).forEach((el) => {
      // skip if already processed
      const element = el as HTMLElement;
      if (element.dataset['whitelisted'] === 'true') return;
      //   console.log(el);
      element.style.pointerEvents = 'auto';
      element.dataset['whitelisted'] = 'true';
    });
  });
}

export function preventInteractions(containerSelector = '.form-container'): void {
  const container = document.querySelector(`${containerSelector}`) as HTMLElement;
  if (!container) return;
  applyLock(container);
  container.setAttribute('aria-disabled', 'true');
  applyWhitelist(container);
}

let interactionObserver: MutationObserver | undefined;
export function startInteractionObserver(): void {
  const container = document.querySelector('.form-container') as HTMLElement;
  if (!container) return;
  interactionObserver?.disconnect();
  interactionObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        // Only apply whitelist to new DOM
        applyWhitelist(node);
      });
    }
  });
  interactionObserver.observe(container, {
    childList: true,
    subtree: true,
  });
}
